// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { potWithLid16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-pot-with-lid': IconPotWithLid;
    }
}

/**
 * The icon component for the 'potWithLid' icon
 */
export class IconPotWithLid extends Icon {
    public constructor() {
        super(potWithLid16X16);
    }
}

registerIcon('icon-pot-with-lid', IconPotWithLid);
export const iconPotWithLidTag = 'nimble-icon-pot-with-lid';
